import React, { useContext, useEffect, useState } from 'react';
import themeContext from '../../context/theme/themeContext';
import SpoolLogo from '../../assets/logos/SpoolLogo';
import AccountDetails from './AccountDetails';
import Dropdown from '../../components/Dropdown';
import ClickAwayListener from 'react-click-away-listener';
import { formatAmountWithSuffix } from '../../helpers/formats';
import useTotalSpoolTvr from '../../hooks/web3/general/useTotalSpoolTvr';
import { NavLink, useLocation } from 'react-router-dom';
import { isActiveRoute, vaultRoutes } from '../../routes';
import { SupportedChains } from '../../config/constants';
import { useWeb3React } from '@web3-react/core';
import ChainSelector from './ChainSelector';

const navLinks = [
    {
        to: '/',
        label: 'Spool App',
    },
    {
        to: '/platform-summary',
        label: 'Your Vault',
    },
    {
        to: '/staking',
        label: 'Spool Staking',
    },
    {
        to: '/egov',
        label: 'E-Gov',
    },
];

const Navbar: React.FC = () => {
    const { theme } = useContext(themeContext);

    const [sticky, setSticky] = useState(false);
    const [open, setOpen] = useState(false);

    const location = useLocation();

    const { chainId } = useWeb3React();

    const { totalSpoolTvr } = useTotalSpoolTvr();

    const show = () => setOpen((prev) => !prev);

    const hide = () => {
        if (!open) return;

        setOpen(false);
    };

    useEffect(() => {
        const scrollListener = () => {
            if (window.scrollY > 10) {
                setSticky(true);
                return;
            }
            setSticky(false);
        };

        window.addEventListener('scroll', scrollListener);

        return () => {
            window.removeEventListener('scroll', scrollListener);
        };
    }, []);

    return (
        <header className={`${theme} ${sticky ? 'sticky' : ''}`}>
            <div className='header-container'>
                <div className='container'>
                    <a href='https://spool.fi/' className='logo-container'>
                        {/* <div className='logo-container'> */}
                        <SpoolLogo />
                        {/* </div> */}
                        {/* <span>Spool</span> */}
                    </a>
                    <ClickAwayListener onClickAway={hide}>
                        <nav>
                            <div className={'active-link'} onClick={show}>
                                {location.pathname === '/staking'
                                    ? '$SPOOL Staking'
                                    : location.pathname === '/egov'
                                    ? 'E-Gov'
                                    : vaultRoutes.includes(location.pathname)
                                    ? 'Spool Vault'
                                    : 'Spool App'}
                            </div>
                            <Dropdown open={open}>
                                {navLinks.map(({ to, label }) => {
                                    if (
                                        chainId === SupportedChains.ARBITRUM_ONE &&
                                        (label === 'Spool Staking' || label === 'E-Gov')
                                    )
                                        return null;

                                    return (
                                        <NavLink
                                            exact
                                            activeClassName='active'
                                            className={
                                                isActiveRoute(location.pathname, to)
                                                    ? 'active'
                                                    : undefined
                                            }
                                            to={
                                                chainId ===
                                                    SupportedChains.ARBITRUM_ONE &&
                                                label === 'Your Vault'
                                                    ? `/your-spools${
                                                          chainId ===
                                                          SupportedChains.ARBITRUM_ONE
                                                              ? '?network=arbitrum'
                                                              : ''
                                                      }`
                                                    : to +
                                                      `${
                                                          chainId ===
                                                          SupportedChains.ARBITRUM_ONE
                                                              ? '?network=arbitrum'
                                                              : ''
                                                      }`
                                            }
                                            key={label}
                                        >
                                            {label}
                                        </NavLink>
                                    );
                                })}
                            </Dropdown>

                            <div className='total-spool'>
                                <p>
                                    Total Spool TVR{' '}
                                    <span>
                                        ${formatAmountWithSuffix(totalSpoolTvr || 0)}
                                    </span>
                                </p>
                            </div>
                        </nav>
                    </ClickAwayListener>
                    <AccountDetails />
                </div>
                <div className='chain-selector-div'>
                    <ChainSelector />
                </div>
            </div>
        </header>
    );
};

export default Navbar;
